/** Aggregate platform panels so closing one cannot resume a game behind another. */
export function createOverlayPauseRegistry() {
  const owners = new Set<symbol>();
  const listeners = new Set<() => void>();
  let published = false;
  const publish = () => {
    const active = owners.size > 0;
    if (active === published) return;
    published = active;
    listeners.forEach((listener) => listener());
  };
  return {
    active: () => owners.size > 0,
    subscribe(listener: () => void) { listeners.add(listener); return () => { listeners.delete(listener); }; },
    acquire() {
      const owner = Symbol();
      owners.add(owner);
      publish();
      return () => {
        owners.delete(owner);
        // Panel-to-panel transitions should not briefly resume the game.
        queueMicrotask(publish);
      };
    },
  };
}
export const gameOverlayPause = createOverlayPauseRegistry();
